import React, { PureComponent } from 'react'
import { VictoryTooltip } from 'victory'
import { Portal } from 'react-portal'
import DefaultTooltip from './DefaultTooltip'

class ChartTooltip extends PureComponent {
  static defaultEvents = VictoryTooltip.defaultEvents

  constructor (props) {
    super(props)
    this.state = { position: true }
  }

  calcTooltipPosition = (node, x, y) => {
    if (node && this.state.x !== x && this.state.y !== y) {
      this.setState({
        x: x,
        y: y,
        position: node.getBoundingClientRect()
      })
    }
  }

  render () {
    const { x, y, active, tooltipComponent } = this.props

    if (!active) {
      return null
    }

    return (
      <g>
        <circle
          className='chart__line__invisible'
          cx={x}
          cy={y}
          r={0}
          ref={node => this.calcTooltipPosition(node, x, y)}
        />
        <Portal>
          <div
            className='tooltip'
            style={{
              position: 'absolute',
              left: this.state.position.x,
              top: this.state.position.y,
              zIndex: 6000
            }}
          >
            {React.cloneElement(tooltipComponent, { ...this.props })}
          </div>
        </Portal>
      </g>
    )
  }
}

ChartTooltip.defaultProps = {
  tooltipComponent: <DefaultTooltip />
}

export default ChartTooltip



// WEBPACK FOOTER //
// ./src/charts/ChartTooltip.js